export default "__VITE_ASSET__CoPAcnTd__"